module.exports = __webpack_public_path__ + "bfb8c17d090ddf690c318ef216a6c87a.svg";